import type { SVGProps } from 'react';
const DawnFlagUS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-US_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-US_svg__a)">
      <path
        fill="#D02F44"
        fillRule="evenodd"
        d="M22 0H0v1.067h22zm0 2.133H0V3.2h22zM0 4.267h22v1.066H0zM22 6.4H0v1.067h22zM0 8.533h22V9.6H0zm22 2.134H0v1.066h22zM0 12.8h22v1.067H0zm22 2.133H0V16h22z"
        clipRule="evenodd"
      />
      <path fill="#46467F" d="M0 0h9.429v7.467H0z" />
      <g filter="url(#dawn-flag-US_svg__b)">
        <path
          fill="url(#dawn-flag-US_svg__c)"
          fillRule="evenodd"
          d="M2.095 1.6a.53.53 0 0 1-.523.533.53.53 0 0 1-.524-.533c0-.295.234-.533.524-.533.289 0 .523.238.523.533m2.096 0a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.533.524-.533s.524.238.524.533m1.571.533c.29 0 .524-.238.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.533.524.533m2.62-.533a.53.53 0 0 1-.525.533.53.53 0 0 1-.523-.533c0-.295.234-.533.523-.533s.524.238.524.533M2.618 3.2c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235.533.524.533m2.62-.533a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.234-.534.524-.534.289 0 .523.24.523.534m1.57.533c.29 0 .525-.239.525-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.234.533.524.533m1.572.533a.53.53 0 0 1-.524.534.53.53 0 0 1-.523-.534c0-.294.234-.533.523-.533s.524.239.524.533m-2.619.534c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534m-1.571-.534a.53.53 0 0 1-.524.534.53.53 0 0 1-.524-.534c0-.294.235-.533.524-.533s.524.239.524.533m-2.62.534c.29 0 .524-.24.524-.534a.53.53 0 0 0-.523-.533.53.53 0 0 0-.524.533c0 .295.234.534.524.534m1.572.533a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.533.524-.533s.524.238.524.533m1.572.533c.289 0 .523-.238.523-.533a.53.53 0 0 0-.523-.533.53.53 0 0 0-.524.533c0 .295.234.533.524.533M7.334 4.8a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.234-.533.524-.533s.524.238.524.533m.523 1.6c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.523.534c0 .294.234.533.523.533m-1.571-.533a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.235-.534.524-.534s.524.24.524.534m-2.62.533c.29 0 .525-.239.525-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235.533.524.533m-1.57-.533a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.234-.534.524-.534.289 0 .523.24.523.534"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-US_svg__c"
        x1={1.048}
        x2={1.048}
        y1={1.067}
        y2={6.4}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F0F0F0" />
      </linearGradient>
      <filter
        id="dawn-flag-US_svg__b"
        width={7.333}
        height={6.333}
        x={1.048}
        y={1.067}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1857" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1857" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagUS;
